@let $number = number();
@let $readOnly = readOnly();
@let $status = status();

@if (isSimple()) {
  <section
    class="mbs-steps_item"
    [class.-active]="!lastStep">
    <div class="d-flex">
      <div class="d-flex flex-column">
        <div class="mbs-steps_item-index">
          {{ $number }}
        </div>
        <div class="mbs-steps_item-content flex-grow-1"></div>
      </div>
      <div class="flex-grow-1">
        <ng-content select="[body]" />
      </div>
    </div>
  </section>
} @else {
  <section
    class="mbs-steps_item"
    [ngClass]="[$status ? (lastStep && $status === 'active' ? '' : '-' + $status) : $readOnly && !lastStep ? '-active' : '']">
    <header class="mbs-steps_item-header">
      <div class="col-auto">
        <div class="row align-items-center">
          <div class="col-auto">
            <div class="mbs-steps_item-index">
              @if ($status === 'success' || singleStep) {
                <span class="mbs-steps_item-index-ico ico ico-ok"></span>
              }
              {{ $status === 'success' || singleStep ? '' : $number }}
            </div>
          </div>
          <div class="col-auto">
            <h5 class="mbs-steps_item-title">
              <ng-content select="[title]" />
            </h5>
          </div>
        </div>
      </div>
      @if ($status === 'active') {
        <div
          class="col-auto"
          [hidden]="headerControlsContent.innerHTML.length === 0">
          <div
            class="row mbs-steps_item-header_controls"
            #headerControlsContent>
            <ng-content select="[controls]" />
          </div>
        </div>
      }
    </header>
    @if ($status === 'active' || $readOnly) {
      <div class="mbs-steps_item-content">
        <div
          class="mbs-steps_item-text small"
          [class]="bodyClasses()">
          <ng-content select="[body]" />
        </div>
        <ng-content select="[bodyTemplate]" />
      </div>
    }
  </section>
}
